import { render } from "./RecursoCaracola.vue?vue&type=template&id=69b8ba06&scoped=true"
import script from "./RecursoCaracola.vue?vue&type=script&lang=js"
export * from "./RecursoCaracola.vue?vue&type=script&lang=js"

import "./RecursoCaracola.vue?vue&type=style&index=0&id=69b8ba06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b8ba06"]])

export default __exports__